// The PropertyLeads refund question (`_refund_question_fields.html`).  The Note for PL
// follows the form's own note (`data-refund-note-source`) in either order the rep fills
// them, until it holds text the rep wrote there (anything but the last copied value).
function followSource(form) {
    const note = form && form.querySelector('[data-refund-note-source]');
    if (!note) return;
    const copied = note.dataset.refundNoteCopied || '';
    if (note.value.trim() && note.value !== copied) return;
    const source = form.querySelector(note.dataset.refundNoteSource);
    if (!source) return;
    note.value = source.value.trim();
    note.dataset.refundNoteCopied = note.value;
}

document.addEventListener('change', function (event) {
    if (event.target.name === 'refund_reason') followSource(event.target.form);
});
document.addEventListener('input', function (event) {
    const form = event.target.form;
    const note = form && form.querySelector('[data-refund-note-source]');
    if (note && event.target.matches(note.dataset.refundNoteSource)) followSource(form);
});
